import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './list.module.css';

const List: FC<{ titles: ListContentTitle[]; contents: ListContent[] }> = ({
  titles,
  contents,
}) => {
  const navigate = useNavigate();

  const renderTitles = () => {
    if (!titles) return null;

    return titles.map((item, index) => (
      <th key={index} style={{ textAlign: item.align ? item.align : 'left' }}>
        {item.text}
      </th>
    ));
  };

  const renderContents = () => {
    if (!contents) return null;

    return contents.map((content, index) => (
      <tr
        key={index}
        onClick={() => (content.linkTo ? navigate(content.linkTo) : null)}
      >
        {content.data.map((item, index) => (
          <td
            key={index}
            style={{
              ...item.customStyle,
              textAlign: item.align ? item.align : 'left',
            }}
          >
            <p dangerouslySetInnerHTML={{ __html: item.text }}></p>
            {item.subText && <p className={styles.subText}>{item.subText}</p>}
          </td>
        ))}
      </tr>
    ));
  };

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>{renderTitles()}</tr>
        </thead>
        <tbody>{renderContents()}</tbody>
      </table>
    </div>
  );
};

export default List;
